// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import moment from 'moment';

import { Scheduler, CreateEventModal, Event } from '../Components/index';
import getLanguage from '../libs/Languages';

class FavoritesRelayContainer extends Component {

  setSchedulerDateRange = (startDate, endDate) => {
    this.props.relay.setVariables({
      startDate: startDate.add(1, 'second').unix(),
      endDate: endDate.unix(),
    });
  }

  props: {
    viewer: Object,
    relay: Object,
  }

  _forceFetch = () => {
    this.props.relay.forceFetch();
  }

  render() {
    const { me } = this.props.viewer;
    const meObj = {
      id: me.id,
      email: me.email,
      displayName: me.displayName,
    };
    const contactsSelected = [meObj, ...me.favorites.contacts];

    return (
      <div className="favorites-container" style={{ position: 'relative' }}>
        <Scheduler
          viewer={this.props.viewer}
          contact={this.props.viewer.contact}
          contactsSelected={contactsSelected}
          languagedata={getLanguage()}
          startDate={moment.unix(this.props.relay.variables.startDate)}
          endDate={moment.unix(this.props.relay.variables.endDate)}
          setDateRange={this.setSchedulerDateRange}
          forceFetch={this._forceFetch}
          changeSelectedTo={null}
          relay={this.props.relay}
          start={this.props.relay.variables.startDate}
          end={this.props.relay.variables.endDate}
          width={120}
        />
      </div>
    );
  }
}

const uiState = {
  startDate: moment().startOf('day').add(1, 'second'),
  endDate: moment().endOf('day'),
};

const fragContact = Relay.QL`
  fragment on Contact {
    id
    displayName
    isFavorite
    email
  }
`;

export default Relay.createContainer(FavoritesRelayContainer, {
  initialVariables: {
    startDate: uiState.startDate.unix(),
    endDate: uiState.endDate.unix(),
  },
  fragments: {
    viewer: (vars) => Relay.QL`
      fragment on Viewer {
        contact(email: null) {
          ${fragContact},
        }
        me {
          id
          email
          displayName
          favorites {
            contacts {
              ${fragContact},
            }
          }
        }
        ${CreateEventModal.getFragment('viewer')},
        ${Event.getFragment('event', vars)},
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Containers/FavoritesContainer.js